@use "variables" as *;

.mainContainer {
  width: 100%;
  display: flex;
}

.mainDiv {
  padding: $spacing-m $spacing-s 0 $spacing-m;
  display: flex;
  flex-grow: 1;
}

.list {
  flex-grow: 1;
  overflow: auto;
}

.firstItemCard {
  margin: 0 $spacing-s $spacing-s;
}

.itemCard {
  margin: $spacing-s;
}

.lastItemCard {
  margin: $spacing-s $spacing-s $spacing-m $spacing-s;
}

.cardDiv {
  padding: $spacing-m;
}

.graphsDiv {
  width: 50%;
  padding-bottom: $spacing-m;
  padding-right: $spacing-s;
  padding-left: $spacing-s;
}
